<div class="add-module-container">
  <div class="top-section">
    <div class="title">
      <div class="main-title">Add a new Module</div>
      <div class="sub-title">
        <!-- Lorem ipsum, dolor sit amet consectetur adipisicing. -->
      </div>
    </div>
    <div class="close-btn" (click)="onClickCancel()">
      <i class="fa-solid fa-xmark"></i>
    </div>
  </div>
  <div class="form-section" [formGroup]="moduleForm">
    <div class="left-section">
      <input name="title" formControlName="title"  autocomplete="off" placeholder="title" />
      <textarea
        name="description"
        id=""
        formControlName="description"
        cols="30"
        rows="10"
        placeholder="description"
      ></textarea>
      <input type="file" (change)="onFileUpload($event)" multiple id="file-input" autocomplete="off" placeholder="upload a file">
      <label for="file-input"> <span class="text">Upload a file</span>  <span class="file-text">{{fileName}}</span> </label>
    </div>
    <div class="right-section">
      <input type="number" formControlName="serialNo" placeholder="serial number">
      <input type="text" autocomplete="off" formControlName="duration" placeholder="module duration">
      <!-- <input type="file" autocomplete="off" placeholder="upload a course material">
      <input name="title" autocomplete="off" placeholder="specific course fee" /> -->
      <img src="../../../assets/images/icon 08 (1).png" alt="">
    </div>
  </div>
  <div class="btn-section">
    <div class="module-btn">
      <div class="btn-section">
        <button type="submit" *ngIf="!isUpdate && !isLoading" (click)="onCreateModule()">
          Create Module
        </button>
        <button type="submit" *ngIf="isUpdate && !isLoading" (click)="onUpdateModule()">
          Update Module
        </button>
        <button type="submit" *ngIf="!isUpdate && isLoading">
          Creating
          <i class="fa-solid fa-spinner fa-spin"></i>
        </button>
        <button type="submit" *ngIf="isUpdate && isLoading">
          Updating
          <i class="fa-solid fa-spinner fa-spin"></i>
        </button>
        <!-- <small class="required-error">Please enter required fields!</small> -->
      </div>
    </div>
    <div class="quiz-btn">
      <button type="submit" *ngIf="!isUpdate" [ngClass]="{'disabled-btn': disableQuizBtn}" [disabled]="disableQuizBtn" (click)="onUpdateQuiz()">Add Quiz</button>
      <button type="submit" *ngIf="isUpdate"  [ngClass]="{'disabled-btn': disableQuizBtn}"  [disabled]="disableQuizBtn" (click)="onUpdateQuiz()">Update Quiz</button>
    </div>
    <!-- <small class="required-error">Please enter required fields!</small> -->
  </div>
</div>
